module.exports = __webpack_public_path__ + "img/wind-decoration-with-plants.bb0aae6f.jpg";